import React from 'react';
import type { DeletedOrganizationItem } from '@/types';

export function useDeletedOrganizationsSorting(organizations: DeletedOrganizationItem[]) {
  const [sortDescriptor, setSortDescriptor] = React.useState<{
    column: keyof DeletedOrganizationItem;
    direction: 'ascending' | 'descending';
  } | null>(null);

  const sortedOrganizations = React.useMemo(() => {
    if (!sortDescriptor) return organizations;

    const { column, direction } = sortDescriptor;

    return [...organizations].sort((a, b) => {
      const aValue = a[column];
      const bValue = b[column];

      if (aValue === null || aValue === undefined) return 1;
      if (bValue === null || bValue === undefined) return -1;

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        const comparison = aValue.localeCompare(bValue);
        return direction === 'ascending' ? comparison : -comparison;
      }

      if (typeof aValue === 'number' && typeof bValue === 'number') {
        const comparison = aValue - bValue;
        return direction === 'ascending' ? comparison : -comparison;
      }

      if (aValue instanceof Date && bValue instanceof Date) {
        const comparison = aValue.getTime() - bValue.getTime();
        return direction === 'ascending' ? comparison : -comparison;
      }

      return 0;
    });
  }, [organizations, sortDescriptor]);

  return {
    sortDescriptor,
    setSortDescriptor,
    sortedOrganizations
  };
}
